import Signup from "../CrosswalkSignup";

const Insomania = () => {
  return (
    <>
      <Signup />
    </>
  );
};

export default Insomania;
